export default __webpack_public_path__ + "static/media/nl.8e191e54.svg";